import React from 'react'
import renderHTML from 'react-render-html'
import './styles.scss'

export class Episode extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      isMobile: window.innerWidth < 768
    }
  }

  render() {
    return (
      <div>
        {this.state.isMobile || this.props.isArchived ? (
          <div className='episode'>
            <div className='content'>
              <h3>
                <span>Folge {this.props.episodeNr}</span>
              </h3>
            </div>
            <div className='poster'>
              <img src={this.props.photo} />
            </div>
            <div className='title'>
              <h2>{this.props.name}</h2>
              <div className='subline'>
                <div className='cards-icon'>
                  <img src={require('./cards-mobile.svg')} />
                </div>
                <div className='tags'>{renderHTML(this.props.tags)}</div>
              </div>
            </div>
            <iframe
              height='52px'
              width='100%'
              frameBorder='no'
              scrolling='no'
              seamless
              src={
                'https://player.simplecast.com/' +
                this.props.simpleCastID +
                '?dark=true'
              }
            ></iframe>
          </div>
        ) : (
          <div className='episode'>
            <div className='content'>
              <h3>
                <span>Folge {this.props.episodeNr}</span>
              </h3>
              <div className='title'>
                <h2>{this.props.name}</h2>
                <div className='subline'>
                  <div className='cards-icon'>
                    <img src={require('./cards.svg')} />
                  </div>
                  <div className='tags'>{renderHTML(this.props.tags)}</div>
                </div>
              </div>
              <iframe
                height='52px'
                width='100%'
                frameBorder='no'
                scrolling='no'
                seamless
                src={
                  'https://player.simplecast.com/' +
                  this.props.simpleCastID +
                  '?dark=true'
                }
              ></iframe>
            </div>
            <div className='poster'>
              <img src={this.props.photo} />
            </div>
          </div>
        )}
        <div className='about'>
          <div className='quote'>{renderHTML(this.props.quote)}</div>
          {this.props.about}
        </div>
      </div>
    )
  }
}

export default Episode
